import { DirectiveBase } from '../angular-directive-base.directive';

/**
* Provides a menu button for rapid ad-hoc status value changes
*/
export class StatusMenuButton extends DirectiveBase {
  constructor() {
    super();
    this.restrict = 'E';
    this.scope = {
      currentStatus: '=',
      setStatus: '&?',
      getAvailableStatuses: '&?',
      disabled: '=ngDisabled'
    };

    this.templateUrl = 'app/angularJS/components/status-menu-button/status-menu-button.html';
    this.controller = 'StatusMenuButtonController';
    this.controllerAs = 'vm';
    this.bindToController = true;
  }
}